import React, { useEffect, useMemo, useRef, useState } from "react";
import { YellowButton } from "../../components/YellowButton";
import { Link, useNavigate } from "react-router-dom";
import { BorderedPageLayout } from "../BorderedPageLayout";
import { InputField } from "../../components/InputField";
import {
  AddIcon,
  ArrowRight,
  AvatarIcon,
  CheckedCircle,
  CreateSheet,
  HeartIcon,
  SearchIcon,
  TrashIcon,
  UncheckedCircle,
  AddMat,
  InfoIcon,
} from "../../icons";
import { PatientItem } from "../../components/ListItems/PatientItem";
import { AnalysisItem } from "../../components/ListItems/AnalysisItem";
import {
  handleAnalysisInfoModal,
  handleTemplateSheetCreateModal,
} from "../../features/modals/modalsSlice";
import { CartItem } from "../../components/ListItems/CartItem";
import styles from "./cart.module.scss";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { clearCart, removeProduct } from "../../features/cart/cartSlice";
import {
  createOrder,
  setOrderBonusesTotal,
  setCurrentCategory,
  resetPatient,
  resetOrderErr,
} from "../../features/order/orderSlice";
import { CreateOrderReq } from "../../types/api/orders.api.types";
import { BackButton } from "../../components/BackButton";
import useTheme from "../../hooks/useAppColor";
import { PlaceIcon } from "../../icons";
import {
  Select,
  ConfigProvider,
  DatePicker,
  Space,
  Checkbox,
  Avatar,
} from "antd";
import { getFilials } from "../../features/products/productSlice";
import { getProductById } from "../../features/current-data/currentData";
import type { DatePickerProps } from "antd";
import RU from "antd/es/locale/ru_RU";
import dayjs from "dayjs";
import ruRU from "antd/es/locale/ru_RU";
import "dayjs/locale/ru"; // Важно: импортируем русскую локаль для dayjs
import { DatePicker as MobileDatePicker } from "antd-mobile";
import { FilialApi } from "../../types/api/utils.api.types";
// Инициализируем русскую локаль для dayjs
dayjs.locale("ru");

export const OrderCart = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const getTheme = useTheme();

  const cartProducts = useAppSelector((state) => state.cart.items);
  const cartTotalPrice = useAppSelector((state) => state.cart.totalPrice);
  const handleCreateTemplate = () => dispatch(handleTemplateSheetCreateModal());
  const [pickerVisible, setPickerVisible] = useState(false);

  const { patientData, sending, success, err, bonuses, usiMeta } =
    useAppSelector((state) => state.order);
  const {
    data: { agent_procent },
  } = useAppSelector((state) => state.profile);
  const [currentFilial, setCurrentFilial] = useState<number>(0);
  const [visitDate, setvisitDate] = useState<any>(
    dayjs().format("YYYY-MM-DD HH:mm"),
  );

  const cartItems = useAppSelector((state) => state.cart.items);
  const filials = useAppSelector((state) => state.products.filials);

  const defaultValue = dayjs();
  const minutes = defaultValue.minute();
  const roundedMinutes =
    minutes % 5 === 0 ? minutes : Math.ceil(minutes / 5) * 5;
  const currentTime = defaultValue.minute(roundedMinutes).second(0).toDate();
  const [isDateTimeDisabled, setIsDateTimeDisabled] = useState(false);
  const isUsiFlow = Boolean(usiMeta);

  useEffect(() => {
    if (filials.length === 0 || (filials.length !== 0 && !isUsiFlow)) {
      dispatch(getFilials({ type: 1 }));
    }
  }, [filials.length, dispatch, isUsiFlow]);

  const handleClearCart = () => {
    dispatch(clearCart());
  };

  const handleOrder = () => {
    const data: CreateOrderReq = {
      user_id: patientData.id,
      analiz: cartProducts.map((item) => item.id),
      doc: isUsiFlow ? usiMeta!.doc_id : currentFilial,
      visit: isUsiFlow
        ? `${usiMeta!.date} ${usiMeta!.time}`
        : isDateTimeDisabled
          ? ""
          : visitDate,
      type: isUsiFlow ? "usi" : "analysis",
    };

    dispatch(createOrder(data));
  };

  const handleToSelectingCategory = () => {
    navigate("/order/category");
  };

  useEffect(() => {
    if (success) {
      dispatch(setOrderBonusesTotal((cartTotalPrice / 100) * agent_procent));
      navigate("/order-sent");
      handleClearCart();
    }
  }, [success]);

  useEffect(() => {
    return () => {
      dispatch(resetOrderErr());
    };
  }, []);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  type GroupedFilialOption = {
    label: string;
    value: string;
    original: FilialApi;
  };

  type GroupedFilials = {
    [city: string]: GroupedFilialOption[];
  };

  const groupFilialsByCity = (items: FilialApi[]) => {
    const grouped: GroupedFilials = {};

    items.forEach((filial) => {
      if (!grouped[filial.city]) {
        grouped[filial.city] = [];
      }

      grouped[filial.city].push({
        label: `${filial.address}`,
        value: filial.id.toString(),
        original: filial,
      });
    });

    return Object.keys(grouped).map((city) => ({
      label: <h1 style={{ fontSize: 18, fontWeight: 800 }}>{city}</h1>,
      options: grouped[city],
    }));
  };

  const handleChange = (_value: string, option: any) => {
    let cat = Nurses.find(
      (nurse) => nurse.crm_id === Number(option.original.id),
    );
    console.log(cat);
    setCurrentFilial(cat!.cat);
  };

  const Nurses = [
    {
      crm_id: 184,
      cat: 23,
    },
    {
      crm_id: 1,
      cat: 3,
    },
    {
      crm_id: 4,
      cat: 13,
    },
    {
      crm_id: 198,
      cat: 39,
    },
    {
      crm_id: 0,
      cat: 58,
    },
    {
      crm_id: 5,
      cat: 18,
    },
  ];

  const handleOpenProductInfo = (product_id: number) => {
    dispatch(handleAnalysisInfoModal());
    dispatch(getProductById({ id: product_id }));
  };

  const MONTH_NAMES = [
    "янв.",
    "фев.",
    "мар.",
    "апр.",
    "май",
    "июн.",
    "июл.",
    "авг.",
    "сен.",
    "окт.",
    "ноя.",
    "дек.",
  ];

  const datePickerFilter = {
    minute: (val: number) => val % 5 === 0,
  };

  const datePickerLabelRenderer = (type: string, data: number) => {
    switch (type) {
      case "year":
        return `${data} г.`;
      case "month":
        return MONTH_NAMES[data - 1];
      case "day":
        return `${data}`;
      case "hour":
        return `${data} ч`;
      case "minute":
        return `${data} мин`;
      default:
        return data;
    }
  };
  return (
    <BorderedPageLayout
      contentClassName={"f-column-betw"}
      top={
        <div className="f-row-betw">
          <BackButton onClick={handleToSelectingCategory} />
          <h2 className={`title ${getTheme("", "c-white")} fw-6`}>Корзина</h2>
          <div></div>
        </div>
      }
    >
      <div className="f-column-betw f-1 gap-15">
        {/* Блок выбранного пациента */}
        <div
          className={`d-f pd-10 al-center f-row-betw gap-10 search-block w-100p ${getTheme("", "app-bg-dark")}`}
          onClick={() => navigate("/order/patient")}
        >
          <div className="d-f al-center gap-10">
            <Avatar
              size={32}
              src={patientData.image}
              icon={<AvatarIcon width={32} height={32} />}
            />
            <p className={`fz-m ${getTheme("c-dark", "c-white")}`}>
              {patientData.id > 0
                ? `${patientData.first_name} ${patientData.last_name}`.trim()
                : "Пациент не выбран"}
            </p>
          </div>
          <p
            style={{ textDecoration: "underline", whiteSpace: "nowrap" }}
            className={`fz-s ${getTheme("c-dark", "c-lg")}`}
          >
            Сменить
          </p>
        </div>

        {isUsiFlow && (
          <div className={`pd-10 search-block ${getTheme("", "app-bg-dark")}`}>
            <p className={`fz-l fw-5 ${getTheme("c-dark", "c-white")}`}>
              {usiMeta?.filial} - {usiMeta?.doctor} -{" "}
              {dayjs(`${usiMeta?.date}T00:00:00`).format("DD.MM.YYYY")}{" "}
              {usiMeta?.time}
            </p>
          </div>
        )}

        {!isUsiFlow && isDateTimeDisabled && (
          <div className="f-row-betw gap-20">
            <InfoIcon width={40} height={40}></InfoIcon>
            <p className={` ${getTheme("", "c-white")}`}>
              В течение нескольких дней с Вами свяжутся для уточенния удобного
              времени и филиала сдачи анализов
            </p>
          </div>
        )}
        {!isUsiFlow && !isDateTimeDisabled && (
          <>
            <h2 className={`title ${getTheme("", "c-white")}`}>
              Выберите филиал:{" "}
            </h2>
            <div className="f-row-betw">
              <ConfigProvider
                direction="ltr"
                theme={{
                  components: {
                    Select: {
                      activeBorderColor: "#FFCF00",
                      activeOutlineColor: "#FFCF00",
                      hoverBorderColor: "#4D4D4D",
                      optionHeight: 25,
                      optionFontSize: 16,
                      optionSelectedFontWeight: 300,
                      optionSelectedBg: "#FFDA75",
                    },
                  },
                }}
              >
                <Select
                  optionLabelProp="label"
                  defaultValue={"Выберите филиал"}
                  size="large"
                  onChange={handleChange}
                  options={groupFilialsByCity(filials)}
                  style={{ width: "100%", whiteSpace: "normal" }}
                  menuItemSelectedIcon={<PlaceIcon width={15} height={15} />}
                  suffixIcon={<PlaceIcon width={15} height={15} />}
                />
              </ConfigProvider>
            </div>
          </>
        )}

        {!isUsiFlow && !isDateTimeDisabled && (
          <>
            <h2 className={`title ${getTheme("", "c-white")}`}>
              Выберите дату и время визита:{" "}
            </h2>
            <div
              onClick={() => setPickerVisible(true)}
              style={{
                padding: "8px 11px",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                backgroundColor: "#fff",
                cursor: "pointer",
                fontSize: "16px",
                justifyContent: "space-between",
                alignItems: "center",
                minHeight: "40px",
                display: "flex",
              }}
            >
              <span>
                {visitDate ? visitDate : "Нажмите, чтобы выбрать время"}
              </span>
              <PlaceIcon width={15} height={15} /> {/* Или иконка календаря */}
            </div>
            <MobileDatePicker
              visible={pickerVisible}
              onClose={() => setPickerVisible(false)}
              precision="minute"
              defaultValue={currentTime}
              filter={datePickerFilter}
              renderLabel={datePickerLabelRenderer}
              onConfirm={(val) => {
                if (val) {
                  setvisitDate(dayjs(val).format("YYYY-MM-DD HH:mm"));
                }
              }}
              confirmText="Выбрать"
              cancelText="Отмена"
              title="Дата и время визита"
            />
          </>
        )}

        {!isUsiFlow && (
          <Checkbox
            onChange={() => {
              setIsDateTimeDisabled(!isDateTimeDisabled);
              console.log(isDateTimeDisabled);
            }}
          >
            Без времени и даты визита
          </Checkbox>
        )}

        <div className="f-column gap-10">
          <div className="f-row-betw">
            <h2 className={`title ${getTheme("", "c-white")}`}>
              Всего анализов: {cartProducts.length}
            </h2>
            <div className={`${styles.bonuses} gap-10 d-f`}>
              <HeartIcon />
              <p className="c-white fz-l fw-6">
                {~~((cartTotalPrice / 100) * agent_procent)}
              </p>
            </div>
          </div>
          <div className="f-row-betw">
            <div onClick={handleClearCart} className="d-f gap-5 al-center">
              <TrashIcon />
              <p className="fw-5 fz-l c-error">Очистить</p>
            </div>
            <div
              onClick={handleCreateTemplate}
              className=" d-f gap-5 al-center"
            >
              <CreateSheet color={`${getTheme("#1E1F20", "#FFFFFF ")}`} />
              <p className={`title ${getTheme("", "c-white")} fw-5 fz-l`}>
                Создать шаблон
              </p>
            </div>
          </div>
        </div>
        <div className="f-1 p-rel">
          <div className="list p-abs w-100p f-column scrollableItemsList gap-10">
            {cartProducts.map((item) => (
              <CartItem
                key={item.id} // Добавляем key для избежания предупреждений
                removeItem={() =>
                  dispatch(removeProduct({ id: item.id, cost: item.cost }))
                }
                item={item}
                clickHandle={() => handleOpenProductInfo(item.id)}
                del={true}
              />
            ))}
          </div>
        </div>
        <div className="p-rel">
          <p className={`${getTheme("c-dark", "c-white")} fz-l fw-9`}>
            Итого: {cartTotalPrice}&nbsp;₽
          </p>
        </div>
        <div className="f-column gap-5">
          <YellowButton
            onClick={handleOrder}
            loading={sending}
            disabled={cartProducts.length === 0}
          >
            Отправить заказ
          </YellowButton>
          {err ? <p className="fz-m c-error">{err}</p> : null}
        </div>
      </div>
    </BorderedPageLayout>
  );
};
